export const navLinks = [
  { href: "#intro", label: "题材概述" },
  { href: "#timeline", label: "发展脉络" },
  { href: "#films", label: "精选片单" },
  { href: "#themes", label: "看点解析" },
  { href: "#people", label: "代表人物" },
  { href: "#guide", label: "观影指南" },
  { href: "#faq", label: "常见问答" },
];

export const heroStats = [
  { value: "60+", label: "年发展历程" },
  { value: "9", label: "部精选片单" },
  { value: "4", label: "大题材方向" },
  { value: "6", label: "位代表人物" },
];

export const introPoints = [
  {
    icon: "ri-heart-3-line",
    title: "以情感为核心",
    text: "所谓“伦理电影”，指的是以婚恋、欲望、家庭关系与人性抉择为核心冲突的一类剧情片，情感张力往往盖过情节本身。",
  },
  {
    icon: "ri-scan-2-line",
    title: "借欲望讲社会",
    text: "许多作品表面写情欲，实则借由个体关系去折射阶级、权力结构与时代压抑，因此常被影评人当作社会文本解读。",
  },
  {
    icon: "ri-quill-pen-line",
    title: "作者气质明显",
    text: "从金绮泳到朴赞郁、洪常秀，这一类型吸引了大批作者导演，镜头语言、结构与美术常常比故事更具辨识度。",
  },
  {
    icon: "ri-user-star-line",
    title: "影帝影后的舞台",
    text: "由于对表演的依赖极高，这类影片常成为实力派演员突破形象、挑战复杂角色的重要阵地。",
  },
];

export const timeline = [
  {
    year: "1960",
    title: "类型奠基",
    text: "金绮泳的《下女》以心理惊悚的外壳，探讨欲望与阶级的失控，被普遍视为韩国“伦理片”脉络的源头。",
  },
  {
    year: "1990s",
    title: "市场标签成形",
    text: "随着社会风气与审查环境变化，以情感与欲望为切口的剧情片逐渐增多，“伦理电影”成为观众熟悉的市场标签。",
  },
  {
    year: "2000s",
    title: "走向国际影展",
    text: "《丑闻》《处女心经》等作品把这一类型带上国际影展与评论视野，题材开始被当作严肃的作者表达来讨论。",
  },
  {
    year: "2008-2012",
    title: "古装与翻拍热潮",
    text: "《霜花店》《美人图》《银娇》等片接连引发话题，古装宫廷与文学改编成为这一阶段的显著特征。",
  },
  {
    year: "2010s",
    title: "作者化与奖项",
    text: "朴赞郁《小姐》等作品把类型技法与艺术追求结合，在海外斩获奖项，也让更多人重新审视这一题材。",
  },
  {
    year: "当下",
    title: "正版平台时代",
    text: "正版流媒体让这些作品更容易被合法观看，观众的关注点也逐渐从猎奇转向影片的艺术价值与主创表达。",
  },
];

export const themeTabs = [
  {
    id: "class",
    label: "阶级与欲望",
    title: "密室里的权力游戏",
    text: "当人物被关进豪宅、军营或家庭这样的封闭空间，欲望就不再只是私人情感，而变成一次关于阶层与权力的试探。这类作品常常用空间的压迫感，放大人物处境的错位。",
    points: [
      "豪宅、宅邸等封闭空间是常见舞台",
      "主仆、雇佣关系映射现实阶层",
      "欲望的失控往往等同于秩序的崩塌",
    ],
    examples: "代表作品：下女",
  },
  {
    id: "taboo",
    label: "禁忌与情感",
    title: "克制之下的暗涌",
    text: "越是压抑的年代与身份，情感就越难以言说。这一方向的作品偏爱留白与长镜头，把冲突藏在眼神和沉默里，让观众自己体会那种“明知不可为”的张力。",
    points: [
      "以时代背景放大情感的不可得",
      "节奏克制，冲突靠表演推动",
      "常以悲剧或开放式结局收束",
    ],
    examples: "代表作品：人间中毒、银娇",
  },
  {
    id: "court",
    label: "宫廷与权力",
    title: "华服之下的算计",
    text: "古装宫廷是这一类型最华丽的分支。服饰、建筑与礼仪构成强烈的视觉享受，而权力、忠诚与背叛则在其下暗流涌动，把个人情感放进家国叙事里审视。",
    points: [
      "服化道考究，视觉辨识度极高",
      "个人情感与家国命运相互挤压",
      "常改编自历史或经典文学",
    ],
    examples: "代表作品：奸臣、霜花店、丑闻",
  },
  {
    id: "art",
    label: "作者与艺术",
    title: "结构本身就是表达",
    text: "对作者导演而言，题材只是入口，叙事结构与影像语言才是重点。分章、倒叙、重复与留白被大量使用，让影片在类型之外获得更强的艺术张力。",
    points: [
      "叙事结构复杂，信息分批释放",
      "美术与摄影具有鲜明个人风格",
      "常进入国际影展与获奖名单",
    ],
    examples: "代表作品：小姐、处女心经、美人图",
  },
];

export const people = [
  {
    name: "金绮泳",
    role: "导演 · 类型奠基者",
    text: "以《下女》等作品开创性地把欲望、阶级与心理惊悚熔于一炉，其风格被后世反复致敬与翻拍。",
    photo:
      "https://readdy.ai/api/search-image?query=Illustrative%20portrait%20of%20a%20vintage%20East%20Asian%20film%20director%20in%20studio%20light%2C%20warm%20amber%20and%20sepia%20tones%2C%20textured%20painterly%20style%2C%20cinematic%20mood%2C%20no%20text&width=600&height=800&seq=kfilm-person-01&orientation=portrait",
  },
  {
    name: "朴赞郁",
    role: "导演 · 作者化代表",
    text: "以精密的结构、强烈的美术设计著称，擅长把类型片拍出作者气质，作品长期活跃于国际影展。",
    photo:
      "https://readdy.ai/api/search-image?query=Illustrative%20portrait%20of%20an%20East%20Asian%20film%20director%20with%20glasses%20in%20dramatic%20side%20light%2C%20deep%20crimson%20accents%2C%20textured%20painterly%20style%2C%20cinematic%20mood%2C%20no%20text&width=600&height=800&seq=kfilm-person-02&orientation=portrait",
  },
  {
    name: "洪常秀",
    role: "导演 · 结构叙事",
    text: "偏爱日常对话与重复结构，用极低的成本与高度个人化的视角，持续书写现代人的情感与犹豫。",
    photo:
      "https://readdy.ai/api/search-image?query=Illustrative%20portrait%20of%20an%20East%20Asian%20indie%20film%20director%20in%20soft%20window%20light%2C%20muted%20beige%20and%20amber%20tones%2C%20textured%20painterly%20style%2C%20no%20text&width=600&height=800&seq=kfilm-person-03&orientation=portrait",
  },
  {
    name: "全度妍",
    role: "演员 · 影后",
    text: "凭借极强的角色跨度成为韩国最具代表性的女演员之一，多次在复杂情感题材中交出重量级表演。",
    photo:
      "https://readdy.ai/api/search-image?query=Illustrative%20portrait%20of%20an%20elegant%20East%20Asian%20actress%2C%20warm%20golden%20light%2C%20deep%20red%20accents%2C%20textured%20painterly%20style%2C%20editorial%20mood%2C%20no%20text&width=600&height=800&seq=kfilm-person-04&orientation=portrait",
  },
  {
    name: "金敏喜",
    role: "演员 · 国际获奖",
    text: "以自然细腻的表演游走于作者电影与类型片之间，是国际影展上最受瞩目的韩国面孔之一。",
    photo:
      "https://readdy.ai/api/search-image?query=Illustrative%20portrait%20of%20an%20East%20Asian%20actress%20in%20moody%20lamp%20light%2C%20muted%20crimson%20and%20ivory%20tones%2C%20textured%20painterly%20style%2C%20no%20text&width=600&height=800&seq=kfilm-person-05&orientation=portrait",
  },
  {
    name: "金高银",
    role: "演员 · 新生代",
    text: "出道即凭《银娇》受到关注，此后在电影与剧集领域持续拓宽戏路，是新生代演员的代表。",
    photo:
      "https://readdy.ai/api/search-image?query=Illustrative%20portrait%20of%20a%20young%20East%20Asian%20actress%20in%20soft%20daylight%2C%20fresh%20warm%20amber%20tones%2C%20textured%20painterly%20style%2C%20no%20text&width=600&height=800&seq=kfilm-person-06&orientation=portrait",
  },
];

export const guideSteps = [
  {
    step: "01",
    icon: "ri-shield-check-line",
    title: "优先选择正版平台",
    text: "这类作品在韩国本土及部分海外地区的正版流媒体上有合法上架。观看前先确认平台是否有版权授权，既清晰稳定，也支持创作者。",
  },
  {
    step: "02",
    icon: "ri-parent-line",
    title: "留意影片分级提示",
    text: "多数作品属于限制级，含成人内容。请确认自己符合观看年龄，并根据分级说明判断题材是否适合自己与同看的家人。",
  },
  {
    step: "03",
    icon: "ri-user-search-line",
    title: "先看导演与年代",
    text: "同一个故事在不同年代会被讲成完全不同的样子。先了解导演风格与拍摄年份，能帮你更快判断这部片是否合口味。",
  },
  {
    step: "04",
    icon: "ri-book-open-line",
    title: "结合评论与花絮",
    text: "这类影片常有丰富的解读空间。看正片之后，再读一读影评、访谈或幕后花絮，往往能发现第一次观看时错过的细节。",
  },
];

export const platforms = [
  { name: "韩国本土平台", text: "如 Wavve、TVING、Coupang Play 等，部分经典与新作会在其上架。" },
  { name: "国际流媒体", text: "如 Netflix、Prime Video 等，视地区版权情况提供部分作品的合法观看。" },
  { name: "数字商店租赁", text: "部分地区可通过官方数字商店按次购买或租赁，清晰度与字幕更有保障。" },
  { name: "影展与院线重映", text: "经典作品常在电影节或艺术院线重映，是感受大银幕质感的好机会。" },
];

export const faq = [
  {
    q: "“韩国伦理电影”具体指什么？",
    a: "它并非严格的学术分类，而是市场与观众对一类以婚恋、欲望、家庭关系与人性抉择为核心冲突的剧情片的统称。这类作品往往情感张力强、表演比重高，并常借个人关系折射社会议题。",
  },
  {
    q: "在哪里可以合法观看这类影片？",
    a: "建议优先选择有版权授权的正版流媒体或数字商店。不同地区上架情况差异较大，可先在主流平台的片库中搜索片名，或关注电影节、艺术院线的重映安排。",
  },
  {
    q: "这些影片适合所有观众吗？",
    a: "多数作品属于限制级，含有成人内容与较强的情感冲突，不适合未成年人观看。观看前请留意影片分级与内容提示，并尊重自己与家人的观影偏好。",
  },
  {
    q: "为什么这类电影常被简化甚至误读？",
    a: "因为题材容易引发猎奇关注，部分讨论会忽略其在叙事结构、表演与美术上的价值。若能结合导演风格、时代背景与影评来理解，往往能看到更丰富的一层。",
  },
  {
    q: "第一次接触这个类型，从哪里开始比较好？",
    a: "可以先从口碑与评价较稳定的经典作品入手，例如《下女》《小姐》等，先建立对这个类型的整体印象，再按兴趣扩展到古装、文艺等不同方向。",
  },
];